import(/* webpackMode: "eager" */ "C:\\Users\\hp\\Documents\\GitHub\\emergeweb\\src\\app\\pharma-bottle\\page.tsx");
